import ImpressionsHandler from '@nykaa/deals-utils/impressions';
import React, { useEffect, useRef, } from 'react';
import Utils from '@nykaa/deals-utils/basic';
import IoElement from '../IOElement';
import { ChipWrapper, FilterChip } from './css';
const Chips = (props) => {
    const { isDesktop, position, cssStyle, text, handleTagClick, selectedTags, trackingData, remoteConfigs, } = props;
    const isSelected = !!selectedTags[position];
    const tagRef = useRef(selectedTags);
    const selectedRef = useRef(null);
    useEffect(() => {
        if (tagRef === null || tagRef === void 0 ? void 0 : tagRef.current) {
            tagRef.current = selectedTags;
            selectedRef.current = !!(tagRef.current[position]);
        }
    }, [selectedTags, tagRef]);
    const chipProps = Object.assign(Object.assign({ button_text: text, button_position: position, button_type: 'filter' }, trackingData), { button_status: !isSelected });
    const { selectedStateBkg, unselectedBorder, selectedText, unselectedText, selectedBorder, unSelectedStateBkg, cornerRadius, padding, ellipsis, } = cssStyle;
    const { ellipsisCategoryFilters: ellipsisCategoryFiltersFromRemoteConfig } = (remoteConfigs === null || remoteConfigs === void 0 ? void 0 : remoteConfigs.configs) || {};
    const handleIntersect = () => {
        ImpressionsHandler.handleImpression(Object.assign(Object.assign({}, chipProps), { widget_filters_selected: tagRef === null || tagRef === void 0 ? void 0 : tagRef.current, button_status: selectedRef === null || selectedRef === void 0 ? void 0 : selectedRef.current }));
    };
    // Todo in phase 2 - required for obeservable
    const emptyCallback = () => { };
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleTagClick(chipProps, isSelected);
    };
    const ellipsisSize = (ellipsisCount) => {
        if (ellipsisCount === 0) {
            return 'unset';
        }
        return ellipsisCount || ellipsisCategoryFiltersFromRemoteConfig;
    };
    const finalEllipsis = ellipsisSize(isDesktop ? ellipsis === null || ellipsis === void 0 ? void 0 : ellipsis.desktop : ellipsis === null || ellipsis === void 0 ? void 0 : ellipsis.web);
    const chipText = (finalEllipsis === 'unset' ? text : Utils.truncateEllipsis(text, finalEllipsis));
    return (React.createElement(ChipWrapper, { isDesktop: isDesktop },
        React.createElement(IoElement, { isServer: false, onIntersect: handleIntersect, onIntersectV2: emptyCallback, exitCallBack: emptyCallback },
            React.createElement("div", { onClick: handleClick, className: "io_wrapper_category_filters" },
                React.createElement(FilterChip, { bkg: isSelected ? selectedStateBkg : unSelectedStateBkg, cornerRadius: cornerRadius, border: isSelected ? selectedBorder : unselectedBorder, text: isSelected ? selectedText : unselectedText, padding: padding, isDesktop: isDesktop },
                    React.createElement("span", { className: "filter-text" }, chipText))))));
};
export default React.memo(Chips);
